import { padStart, round } from 'lodash';
import {
  QCSummaryAgent,
  QCSummaryCall,
  QCSummaryEmotion,
  ViewQCSummaryCall,
  ViewQCSummaryEmotion,
} from 'app/common/services/SmartQC.service';

export type ModalAction = 'open' | 'close';

export enum FormFieldCode {
  START_DATE = 'start_date',
  END_DATE = 'end_date',
}

export function convertDurationInSecondIntoDisplayTimeFormat(duration: number, type: 'full' | 'simple'): string {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  let text = '';

  if (hours > 0) {
    const formattedHours = padStart(hours.toString(), 2, '0');
    const displayHours = type === 'full' ? `${formattedHours} giờ ` : `${formattedHours}h `;
    text += displayHours;
  }

  if (minutes > 0) {
    const formattedMinutes = padStart(minutes.toString(), 2, '0');
    const displayMinutes = type === 'full' ? `${formattedMinutes} phút ` : `${formattedMinutes}m `;
    text += displayMinutes;
  }

  if (seconds > 0) {
    const formattedSeconds = padStart(seconds.toString(), 2, '0');
    const displaySeconds = type === 'full' ? `${formattedSeconds} giây` : `${formattedSeconds}s`;
    text += displaySeconds;
  }

  return text.trim();
}

export function buildQCSummaryCall(qcSummaryCall: QCSummaryCall): ViewQCSummaryCall {
  const totalErrorPercent = !qcSummaryCall.total_qc
    ? 0
    : round((qcSummaryCall.total_error / qcSummaryCall.total_qc) * 100, 2);
  const displayTotalErrorPercent = `${totalErrorPercent}%`;
  const totalSuccessPercent = !qcSummaryCall.total_qc
    ? 0
    : round((qcSummaryCall.total_success / qcSummaryCall.total_qc) * 100, 2);
  const displayTotalSuccessPercent = `${totalSuccessPercent}%`;
  const displayTotalMinutes = qcSummaryCall.total_seconds * 60;
  const displayMaximumDuration = convertDurationInSecondIntoDisplayTimeFormat(
    qcSummaryCall.maximum_duration_seconds,
    'full'
  );
  const displayMinimumDuration = convertDurationInSecondIntoDisplayTimeFormat(
    qcSummaryCall.minimum_duration_seconds,
    'full'
  );

  return {
    ...qcSummaryCall,
    display_total_minutes: displayTotalMinutes,
    display_maximum_duration: displayMaximumDuration,
    display_minimum_duration: displayMinimumDuration,
    display_total_error_percent: displayTotalErrorPercent,
    display_total_success_percent: displayTotalSuccessPercent,
  };
}

export function buildViewQCSummaryEmotion(qcSummaryEmotion: QCSummaryEmotion) {
  let backgroundColor = '';
  let label = '';
  switch (qcSummaryEmotion.emotion) {
    case 'Anger': {
      backgroundColor = '#F00202';
      label = 'Thái độ bực tức cường độ cao';
      break;
    }

    case 'UnHappy': {
      backgroundColor = '#381C7D';
      label = 'Thái độ không hài lòng';
      break;
    }

    case 'MidPriority': {
      backgroundColor = '#099516';
      label = 'Thái độ bình thường, mức độ ưu tiên giám sát trung bình';
      break;
    }

    case 'Normal': {
      backgroundColor = '#FCB859';
      label = 'Thái độ bình thường, mức độ ưu tiên giám sát thấp';
      break;
    }
  }

  const viewQCSummaryEmotion: ViewQCSummaryEmotion = {
    ...qcSummaryEmotion,
    backgroundColor,
    label,
  };

  return viewQCSummaryEmotion;
}

export function buildTableColumnsSummaryAgent() {
  return [
    {
      title: 'Điện thoại viên',
      key: 'caller',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Số cuộc',
      key: 'total_call_per_caller',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: '%',
      key: 'percentage',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}

export function mockDataQCSummaryCall(): QCSummaryCall {
  return {
    total_qc: 100,
    total_seconds: 60,
    maximum_duration_seconds: 20,
    minimum_duration_seconds: 10,
    total_success: 20,
    total_error: 40,
    total_silence_duration: 0,
  };
}

export function mockDataQCSummaryEmotion(): QCSummaryEmotion[] {
  return [
    {
      emotion: 'Anger',
      count: 2,
    },
    {
      emotion: 'UnHappy',
      count: 2,
    },
    {
      emotion: 'MidPriority',
      count: 2,
    },
    {
      emotion: 'Normal',
      count: 2,
    },
  ];
}

export function mockDataQCSummaryAgent(): QCSummaryAgent[] {
  return [
    {
      caller: 'x',
      total_call_per_caller: 29,
      percentage: 20,
    },
  ];
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/summary/summary.util.ts